import { Tabs, Tab, Grid, CircularProgress, Button } from "@material-ui/core";
import { useEffect, useState } from "react";
import FeedbackTable from "./components/Feedback";
import InvitedPeopleTable from "./components/InvitedPeople";
import InvitedPeopleLogsTable from "./components/InvitedPplLogs";
import SearchEngine from "./components/SearchEngine";
import {
  getFeedback,
  getInvitedpplLogs,
  getInvitedppl,
  getReport,
  getRegisterUsers,
  getSuggestionList,
} from "./network_requests";
import { ConfirmInvite, invitationKey } from "../../constants";
import { useHistory } from "react-router";
import ReportTable from "./components/ReportTable";
import RegisteredUsers from "./components/RegisteredUsers";
import SuggestionsListTable from "./components/SuggestionList";
import IndexGraph from "./components/IndexGraph";

const tabStyle = {
  fontFamily: "Source Sans Pro",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "15px",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  color: "#FFFFFF",
};

const AdminPanel = () => {
  const [value, setValue] = useState(1);
  const [feedbackRows, setFeedbackRows] = useState([]);
  const [invitedPplLogsRows, setInvitedPplLogsRows] = useState([]);
  const [invitedPplRows, setInvitedPplRows] = useState([]);
  const [reportRows, setReportRows] = useState([]);
  const [registerUsers, setRegisterUsers] = useState([]);
  const [suggestionList, setSuggestionList] = useState([]);
  const [load, setLoad] = useState(false);
  const history = useHistory();
  const [confirm, setConfirm] = useState(null);

  useEffect(async () => {
    setLoad(true);
    const confirm_ = await ConfirmInvite(invitationKey);
    if (confirm_?.Invitation != "Admin") {
      history.push("/invitation");
    } else {
      setConfirm(confirm_);
      const data_1 = await getFeedback();
      setFeedbackRows(data_1);
      const data_2 = await getInvitedpplLogs();
      setInvitedPplLogsRows(data_2);
      const data_3 = await getInvitedppl();
      setInvitedPplRows(data_3);
      const data_4 = await getReport();
      setReportRows(data_4);
      const data_5 = await getRegisterUsers();
      setRegisterUsers(data_5);
      const data_6 = await getSuggestionList();
      setSuggestionList(data_6);
      setLoad(false);
    }
  }, []);
  return (
    <div
      style={{
        minHeight: "90vh",
        minWidth: "100%",
        backgroundImage:
          "linear-gradient(180deg, #0C3459 0%, #0C3459 16.15%, #438DD2 72.43%)",
      }}
    >
      {load ? (
        <div
          style={{
            minHeight: "50vh",
            minWidth: "50vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Grid container justify="center">
          <div style={{ width: "85%" }}>
            <Grid item xs={12}>
              <Tabs
                value={value}
                indicatorColor="primary"
                variant="scrollable"
                textColor="primary"
                onChange={(e, val) => {
                  setValue(val);
                }}
              >
                <Tab label="Feedback" style={tabStyle} />
                <Tab label="Invited People Logs" style={tabStyle} />
                <Tab label="Invited People" style={tabStyle} />

                <Tab label="Index graph" style={tabStyle} />
                <Tab label="Users" style={tabStyle} />
                <Tab label="Suggestions" style={tabStyle} />
                <Tab label="Search Engine" style={tabStyle} />
                <Tab label="Report" style={tabStyle} />
              </Tabs>
            </Grid>
            <Grid item xs={12} style={{ paddingTop: "10px" }}>
              {value === 0 ? (
                <FeedbackTable rows={feedbackRows} />
              ) : value === 1 ? (
                <InvitedPeopleLogsTable rows={invitedPplLogsRows} />
              ) : value === 2 ? (
                <InvitedPeopleTable
                  rows={invitedPplRows}
                  add_user={confirm?.add_user}
                />
              ) : value === 3 ? (
                <IndexGraph />
              ) : value === 4 ? (
                <RegisteredUsers rows={registerUsers} />
              ) : value === 5 ? (
                <SuggestionsListTable rows={suggestionList} />
              ) : value === 6 ? (
                <SearchEngine />
              ) : (
                <ReportTable rows={reportRows} />
              )}
            </Grid>
          </div>
        </Grid>
      )}
      <Grid
        item
        xs={11}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingTop: "10px",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          style={{ backgroundColor: "white", fontWeight: "bold" }}
          onClick={() => {
            history?.push("/test");
          }}
        >
          Testing
        </Button>
      </Grid>
    </div>
  );
};

export default AdminPanel;
